"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.instrumentSelectorMarginInstruments = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var _reselect = require("reselect");
var _instrumentPositionSelectors = require("../../selectors/instrumentPositionSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var instrumentSelectorMarginInstruments = exports.instrumentSelectorMarginInstruments = (0, _reselect.createSelector)(_instrumentPositionSelectors.instrumentSelectorEnabledInstruments, function (state) {
  return (0, _get["default"])(state, 'margin.instrument.instruments', []);
}, function (instruments, marginInstrumentConfigs) {
  return instruments.filter(function (instrument) {
    return marginInstrumentConfigs.some(function (marginInstrumentConfig) {
      return marginInstrumentConfig.InstrumentId === instrument.InstrumentId && marginInstrumentConfig.IsActive;
    });
  });
});